var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill-content"},[_c('div',{staticClass:"back"},[_c('img',{attrs:{"src":_vm.imgsrc}})]),_vm._v(" "),_c('div',{staticClass:"introduce"},[_c('div',{staticClass:"title"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"word"},[_c('p',[_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fecd89e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/test/Skill.vue
// module id = 291
// module chunks = 0